/**
 * Resolves the current execution stage of the React frontend.
 * Falls back safely to 'production' if not explicitly defined.
 */
export function getAppStage() {
  const stage = (process.env.REACT_APP_STAGE || "").toLowerCase().trim();
  if (["preview", "alpha", "beta", "production"].includes(stage)) {
    return stage;
  }
  return "production";
}
